import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { catchError, take } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

import {
  CartService,
  Product,
  ProductType,
  SRouterLinkWithHrefDirective,
  TranslatePipe,
} from '@speedy/core';
import { SpeedyButtonComponent } from '../../../speedy-button/speedy-button.component';
import { SpeedyQtyComponent } from '../../../speedy-qty/speedy-qty.component';
import { PriceComponent } from '../../../price/price.component';
import { CurrencyComponent } from '../../../currency/currency.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-autocomplete-product-single',
  templateUrl: './autocomplete-product-single.component.html',
  styleUrls: ['./autocomplete-product-single.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SRouterLinkWithHrefDirective,
    CurrencyComponent,
    PriceComponent,
    SpeedyQtyComponent,
    SpeedyButtonComponent,
    TranslatePipe,
    AsyncPipe,
  ],
})
export class AutocompleteProductSingleComponent {
  private readonly cartService = inject(CartService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() set product(value: Product) {
    this._product = value;

    this.productUrl =
      this._product.type_id === ProductType.Bundle
        ? this._product.url_key[0]
        : this._product.url_key;

    this.productName =
      this._product.type_id === ProductType.Bundle
        ? this._product.name[0]
        : this._product.name;
  }
  get product() {
    return this._product;
  }

  @Output() toggleAutocomplete = new EventEmitter<void>();

  private _product!: Product;
  productUrl = '';
  productName = '';
  qty = 1;
  loading = false;
  loadingSuccess = false;

  ProductType = ProductType;

  changeQty(qty: number) {
    if (typeof qty === 'number' && qty >= 0) {
      this.qty = qty;
    }
  }

  addToCart(product: Product) {
    this.loading = true;
    this.loadingSuccess = false;

    this.cartService
      .addToCart(product, this.qty)
      .pipe(
        take(1),
        catchError(() => {
          this.loading = false;
          this.cdr.detectChanges();
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.loading = false;
        this.loadingSuccess = true;
        this.cdr.detectChanges();

        window.setTimeout(() => {
          this.loadingSuccess = false;
          this.cdr.detectChanges();
        }, 1500);
      });
  }
}
